module.exports = "  <div class=\"\">\n    <h1>Document Search</h1>\n    <ng-content></ng-content>\n  </div>"